export default __webpack_public_path__ + "static/media/pen-solid.867a313f.svg";